<p-toast position="top-right" key="preaprobado-toast"></p-toast>

<p-confirmDialog key="preaprobado-confirm" [style]="{ width: '420px' }" acceptLabel="Sí" rejectLabel="No" acceptButtonStyleClass="p-button-success" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>

<div class="preaprobado-container">

  <app-loading *ngIf="cargandoInicial"></app-loading>


  <div [hidden]="cargandoInicial">

  <!-- Header modo MODAL -->
  <div class="preaprobado-header" *ngIf="esModal">
    <span class="preaprobado-titulo">{{ 'GESTORPREAPROBADO.LBL_TITULO' | translate }}</span>
    <button class="btn-cerrar" (click)="cerrar()" title="{{ 'GESTORPREAPROBADO.BTN_CERRAR' | translate }}">
      <img src="assets/icons/preaprobados/ico-cancelar-eliminar-fallido-error-equis-x-cerrar.svg" alt="cerrar" />
    </button>
  </div>

  <!-- Header modo NO MODAL -->
  <div class="preaprobado-header-inline" *ngIf="!esModal">
    <span class="header-inline-campana">
      <img src="assets/icons/preaprobados/ico-notificación-importante-campana-alerta.svg" alt="alerta" />
    </span>
    <span class="header-inline-titulo">{{ 'GESTORPREAPROBADO.LBL_TITULO' | translate }}</span>
  </div>

  <!-- Banner (solo modal) -->
  <div class="preaprobado-banner" *ngIf="esModal">
    <div class="banner-imagen">
      <img src="assets/images/preaprobados/TenderoConCalculadora.png" alt="Tendero con calculadora" />
    </div>
    <div class="banner-contenido">
      <p class="banner-texto">{{ 'GESTORPREAPROBADO.LBL_BANNER_TEXTO' | translate }}</p>
      <span class="badge-vigencia" *ngIf="!!datosCliente?.vigenciaHasta">{{ 'GESTORPREAPROBADO.LBL_VIGENTE_HASTA' | translate }} {{ datosCliente?.vigenciaHasta }}</span>
    </div>
  </div>

  <!-- Info cliente (solo modal) -->
  <div class="preaprobado-cliente" *ngIf="esModal">
    <span class="cliente-nombre">{{ datosCliente?.nombre | frasePrimeraMayuscula : 'palabras' }}</span>
    <span class="cliente-doc">{{ datosCliente?.tipoDocumento }} {{ datosCliente?.numeroDocumento }}</span>
    <div class="btn-billetera" [class.btn-billetera--activo]="billeteraActiva" type="button">
      <img src="assets/icons/preaprobados/ico-celular-telefono-dispositivo-movil.svg" alt="wallet" class="btn-billetera__icono" />
      <span class="btn-billetera__label">{{ 'GESTORPREAPROBADO.LBL_BILLETERA' | translate }}</span>
      <span class="btn-billetera__estado">{{ datosCliente?.tieneWallet ? ('GESTORPREAPROBADO.LBL_BILLETERA_REGISTRADO' | translate) : ('GESTORPREAPROBADO.LBL_BILLETERA_SIN_REGISTRO' | translate) }}</span>
    </div>
  </div>

  <!-- Panel simulador -->
  <div class="simulador-panel" *ngIf="ofertaSimulando">

    <app-loading *ngIf="cargandoSimulador"></app-loading>

    <ng-container *ngIf="!cargandoSimulador">

      <!-- Resultados: visibles solo tras calcular -->
      <div class="simulador-resultados" *ngIf="simulacionCalculada">
        <div class="simulador-resultado-item">
          <span class="simulador-resultado-icono simulador-icono-monto">
            <img src="assets/icons/preaprobados/ico-tipo_de_credito.svg" alt="monto" />
          </span>
          <span class="simulador-resultado-label">{{ 'GESTORPREAPROBADO.LBL_MONTO_APROBADO' | translate }}</span>
          <span class="simulador-resultado-valor">{{ formatMonto(fSimulador.monto.value) }}</span>
        </div>
        <div class="simulador-resultado-item simulador-resultado-item--verde" *ngIf="!producto?.indicadorRotativo">
          <span class="simulador-resultado-icono simulador-icono-cuota">
            <img src="assets/icons/preaprobados/ico-valor_desembolsado.svg" alt="cuota" />
          </span>
          <span class="simulador-resultado-label">
            {{ fSimulador.numeroCuota.value }} {{ 'GESTORPREAPROBADO.LBL_CUOTAS_DE' | translate }}
          </span>
          <span class="simulador-resultado-valor simulador-resultado-verde">
            {{ formatMonto(valorCuota) }}
          </span>
        </div>
      </div>

      <!-- Formulario -->
      <form class="simulador-form" [formGroup]="formSimulador" (ngSubmit)="calcularSimulacion()" novalidate>
        <div class="simulador-campos-row">

          <!-- Monto a solicitar -->
          <div class="simulador-campo simulador-campo--lg">
            <label class="campo-requerido">{{ 'GESTORPREAPROBADO.LBL_MONTO_SOLICITAR' | translate }}</label>
            <!-- Varios montos: dropdown -->
            <p-dropdown *ngIf="montosDisponibles.length > 1"
              formControlName="monto"
              [options]="montosDisponibles"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'GESTORPREAPROBADO.LBL_SELECCIONAR' | translate"
              [style]="{ width: '100%' }"
              (onChange)="onMontoDropdownChange()">
            </p-dropdown>
            <!-- Un solo monto: input editable (valor <= monto preaprobado) -->
            <p-inputNumber *ngIf="montosDisponibles.length <= 1"
              formControlName="monto"
              mode="currency"
              currency="COP"
              locale="es-CO"
              [maxlength]="10"
              autocomplete="off"
              [min]="minMontoVal || 1"
              [max]="maxMontoVal"
              [minFractionDigits]="0"
              [maxFractionDigits]="0"
              [style]="{ width: '100%' }"
              [inputStyle]="{ 'text-align': 'right', width: '100%' }"
              (onInput)="simulacionCalculada = false; valorCuota = 0"
              (onBlur)="onMontoInputBlur()">
            </p-inputNumber>
            <div class="simulador-campo-footer">
              <small class="simulador-maximo" (click)="ciclarHelper($event)"><span>{{ rangoMonto }}</span></small>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fSimulador.monto.invalid">
                <ng-container *ngIf="fSimulador.monto.errors?.['max']">
                  {{ 'GESTORPREAPROBADO.LBL_MAXIMO' | translate }} {{ maxMontoVal | number }}
                </ng-container>
                <ng-container *ngIf="fSimulador.monto.errors?.['min']">
                  {{ 'GESTORPREAPROBADO.LBL_MINIMO' | translate }} {{ minMontoVal | number }}
                </ng-container>
                <ng-container *ngIf="fSimulador.monto.errors?.['required']">
                  {{ 'LBL_REQUERIDO' | translate }}
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Frecuencia de pago -->
          <div class="simulador-campo simulador-campo--md" *ngIf="!producto?.indicadorRotativo">
            <label class="campo-requerido">{{ 'GESTORPREAPROBADO.LBL_FRECUENCIA' | translate }}</label>
            <p-dropdown
              formControlName="idFrecuencia"
              [options]="listFrecuencias"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'GESTORPREAPROBADO.LBL_SELECCIONAR' | translate"
              [style]="{ width: '100%' }"
              (onChange)="calcularCuota(fSimulador.idFrecuencia.value)">
            </p-dropdown>
            <div class="simulador-campo-footer">
              <small class="simulador-maximo">&nbsp;</small>
            </div>
          </div>

          <!-- No. de cuotas -->
          <div class="simulador-campo simulador-campo--md" *ngIf="!producto?.indicadorRotativo">
            <label class="campo-requerido">{{ 'GESTORPREAPROBADO.LBL_NUM_CUOTAS' | translate }}</label>
            <input type="number" pInputText formControlName="numeroCuota" min="1" style="width: 100%; text-align: right;"
                   (blur)="calcularPlazo()"
                   [maxlength]="3"
                   autocomplete="off" />
            <div class="simulador-campo-footer">
              <small class="simulador-maximo" (click)="ciclarHelper($event)"><span>{{ 'PRODUCTO.LBL_MAXIMO' | translate }} {{ producto?.plazoMaximo || '-' }} {{ 'LBL_MESES' | translate | lowercase }}</span></small>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fSimulador.numeroCuota.invalid">
                <ng-container *ngIf="fSimulador.numeroCuota.errors?.['max']">
                  {{ 'GESTORPREAPROBADO.LBL_MAXIMO' | translate }} {{ maxCuotas }}
                </ng-container>
                <ng-container *ngIf="fSimulador.numeroCuota.errors?.['min']">
                  {{ 'GESTORPREAPROBADO.LBL_MINIMO' | translate }} {{ minCuotas }}
                </ng-container>
                <ng-container *ngIf="fSimulador.numeroCuota.errors?.['required']">
                  {{ 'LBL_REQUERIDO' | translate }}
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Plazo (campo reactivo) -->
          <div class="simulador-campo simulador-campo--sm" *ngIf="!producto?.indicadorRotativo">
            <label>{{ 'GESTORPREAPROBADO.LBL_PLAZO' | translate }}</label>
            <span class="falso-combo-texto simulador-plazo-valor">
              {{ fSimulador.plazo.value ?? '-' }}
            </span>
            <div class="simulador-campo-footer">
              <small class="simulador-maximo">&nbsp;</small>
            </div>
          </div>

          <!-- Botones -->
          <div class="simulador-campo-botones">
            <button awButton awColor="green"
                    awIcon="assets/icons/preaprobados/ico-calculadora.svg"
                    [disabled]="calculando || bloqueo"
                    (click)="calcularSimulacion()"
                    *ngIf="!producto?.indicadorRotativo">
              {{ 'GESTORPREAPROBADO.BTN_CALCULAR' | translate }}
            </button>
            <button awButton awColor="green" awFill
                    awIcon="assets/icons/preaprobados/ico-exitoso-check-circulo-si-exito-chulo.svg"
                    [disabled]="!simulacionCalculada"
                    (click)="guardarSimulacion()">
              {{ 'GESTORPREAPROBADO.BTN_GUARDAR' | translate }}
            </button>
          </div>

        </div>

        <!-- Info fija: tasa y vencimiento, siempre visible al abrir el simulador -->
        <div class="simulador-info-fija">
          <div class="simulador-info-item">
            <span class="simulador-resultado-icono">
              <img src="assets/icons/preaprobados/ico-tasa.svg" alt="tasa" />
            </span>
            <span class="simulador-resultado-label">{{ 'GESTORPREAPROBADO.LBL_TASA' | translate }}</span>
            <span class="simulador-resultado-valor">{{ tasaOferta != null ? (tasaOferta | numero:2) + '%' : '-' }}</span>
          </div>
          <div class="simulador-info-item">
            <span class="simulador-resultado-icono">
              <img src="assets/icons/preaprobados/ico-calendario.svg" alt="vencimiento" />
            </span>
            <span class="simulador-resultado-label">{{ 'GESTORPREAPROBADO.LBL_VENCIMIENTO' | translate }}</span>
            <span class="simulador-resultado-valor simulador-resultado-verde">{{ formatVencimiento(ofertaSimulando.fechaFinVigenciaString) }}</span>
          </div>
        </div>

      </form>

    </ng-container>

  </div>

  <!-- Barra de acciones -->
  <div class="preaprobado-acciones">
    <button awButton awColor="red"
            awIcon="assets/icons/preaprobados/ico-fallido-x-error-falla-mal-circulo-cancelar-eliminar.svg"
            (click)="rechazarTodas()" *ngIf="totalRegistros > 1">
      {{ 'GESTORPREAPROBADO.BTN_DESCARTAR_TODAS' | translate }}
    </button>
    <div class="buscador">
      <img src="assets/icons/preaprobados/ico-buscar-lupa-lente.svg" class="buscador-icon" alt="buscar" />
      <input type="text" [placeholder]="'GESTORPREAPROBADO.LBL_BUSCAR' | translate" [(ngModel)]="textoBusqueda" (input)="filtrar()" />
    </div>
  </div>

  <!-- Tabla -->
  <div class="tabla-preaprobados">
    <p-table [value]="ofertasFiltradas"
             [paginator]="true" [rows]="filasPorPagina" paginatorPosition="bottom"
             [showCurrentPageReport]="false"
             [lazy]="true" [totalRecords]="totalRegistros" [loading]="cargando"
             (onLazyLoad)="onLazy($event)" class="table-preaprobados">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="producto">{{ 'GESTORPREAPROBADO.LBL_COL_PRODUCTO' | translate }} <p-sortIcon field="producto"></p-sortIcon></th>
          <th pSortableColumn="monto">{{ 'GESTORPREAPROBADO.LBL_COL_MONTO' | translate }} <p-sortIcon field="monto"></p-sortIcon></th>
          <th pSortableColumn="canal">{{ 'GESTORPREAPROBADO.LBL_COL_CANAL' | translate }} <p-sortIcon field="canal"></p-sortIcon></th>
          <th pSortableColumn="tipoPreaprobado">{{ 'GESTORPREAPROBADO.LBL_COL_TIPO' | translate }} <p-sortIcon field="tipoPreaprobado"></p-sortIcon></th>
          <th>{{ 'GESTORPREAPROBADO.LBL_COL_TASA' | translate }}</th>
          <th pSortableColumn="fechaFinVigenciaString">{{ 'GESTORPREAPROBADO.LBL_COL_VENCIMIENTO' | translate }} <p-sortIcon field="fechaFinVigenciaString"></p-sortIcon></th>
          <th>{{ 'GESTORPREAPROBADO.LBL_COL_ACCIONES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-oferta>
        <tr [class.fila-simulando]="ofertaSimulando === oferta">
          <td class="col-texto">{{ oferta.producto }}</td>
          <td class="col-numero">{{ formatMonto(oferta.monto) }}</td>
          <td class="col-texto">
            <ng-container *ngIf="oferta.canales?.length === 1">
              {{ oferta.canales[0].nombre }}
            </ng-container>
            <ng-container *ngIf="oferta.canales?.length > 1">
              <span class="canales-badge canales-multi">
                {{ oferta.canales.length }} {{ 'PREAPROBADODIGITAL.LBL_CANALES' | translate }}
                <span class="canales-tooltip-custom">
                  <span *ngFor="let c of ordenarCanales(oferta.canales)">• {{ c.nombre }}</span>
                </span>
              </span>
            </ng-container>
            <ng-container *ngIf="!oferta.canales || oferta.canales.length === 0">
              -
            </ng-container>
          </td>
          <td class="col-texto">
            <span class="badge-tipo" [ngClass]="{
              'badge-en-firme': oferta.codigoTipoPreaprobado === TiposPreaprobados.FIRME,
              'badge-no-firme': oferta.codigoTipoPreaprobado === TiposPreaprobados.NOFIRME
            }">
              {{ oferta.tipoPreaprobado | uppercase }}
            </span>
          </td>
          <td class="col-numero">{{ oferta.tasaPerfil != null ? (oferta.tasaPerfil | numero:2) : '-' }}</td>
          <td>
            <span [ngClass]="{ 'vencimiento-hoy': esVencimientoHoy(oferta.fechaFinVigenciaString) }">
              {{ formatVencimiento(oferta.fechaFinVigenciaString) }}
            </span>
          </td>
          <td>
            <div class="acciones-icons">
              <!-- Aceptar: activo si EN FIRME y canal diferente a WALLET/CREDIG -->
              <button class="btn-accion"
                      [class.btn-accion--check-activo]="tieneCanalesAsesor(oferta)"
                      [class.btn-accion--inactivo]="!tieneCanalesAsesor(oferta)"
                      [disabled]="!tieneCanalesAsesor(oferta)"
                      title="{{ 'GESTORPREAPROBADO.BTN_ACEPTAR_OFERTA' | translate }}" (click)="aceptarOferta(oferta)">
                <img src="assets/icons/preaprobados/ico-exitoso-check-circulo-si-exito-chulo.svg" alt="aceptar" />
              </button>
              <!-- Rechazar -->
              <button class="btn-accion btn-accion--x-activo" *ngIf="!isNivelCero"
                      title="{{ 'GESTORPREAPROBADO.BTN_RECHAZAR' | translate }}" (click)="rechazarOferta(oferta)">
                <img src="assets/icons/preaprobados/ico-fallido-x-error-falla-mal-circulo-cancelar-eliminar-redondo.svg" alt="rechazar" />
              </button>
              <!-- Simular -->
              <button class="btn-accion"
                      [class.btn-accion--simulador]="ofertaSimulando !== oferta"
                      [class.btn-accion--simulador-activo]="ofertaSimulando === oferta"
                      title="{{ 'GESTORPREAPROBADO.BTN_SIMULAR' | translate }}" (click)="simularOferta(oferta)">
                <img src="assets/icons/preaprobados/ico-calculadora.svg" alt="simular" />
              </button>
              <!-- Vincular -->
              <button class="btn-accion"
                      [class.btn-accion--vincular]="tieneCanal(oferta, CodigoCanales.DIGITAL)"
                      [class.btn-accion--inactivo]="!tieneCanal(oferta, CodigoCanales.DIGITAL)"
                      [disabled]="!tieneCanal(oferta, CodigoCanales.DIGITAL)"
                      title="{{ 'GESTORPREAPROBADO.BTN_ENVIAR_LINK_P_DIGITAL' | translate }}" (click)="vincularOferta(oferta)">
                <img src="assets/icons/preaprobados/ico-vincular-enlace-link-liga-vinculo.svg" alt="vincular" />
              </button>
              <!-- Enviar -->
              <button class="btn-accion"
                      [class.btn-accion--enviar]="tieneCanal(oferta, CodigoCanales.WALLET) && !oferta.indicadorBilleteraMosi"
                      [class.btn-accion--inactivo]="!tieneCanal(oferta, CodigoCanales.WALLET) || !!oferta.indicadorBilleteraMosi"
                      [disabled]="!tieneCanal(oferta, CodigoCanales.WALLET) || !!oferta.indicadorBilleteraMosi"
                      title="{{ 'GESTORPREAPROBADO.BTN_ENVIAR_LINK_DESCARGA_BILLETERA' | translate }}" (click)="enviarOferta(oferta)">
                <img src="assets/icons/preaprobados/ico-enviar-mensaje-correo.svg" alt="enviar" />
              </button>
              <!-- Invitar a la Billetera: solo visible cuando tiene registro MOSI, sin acción -->
              <button *ngIf="oferta.indicadorBilleteraMosi"
                      class="btn-accion btn-accion--billetera-mosi"
                      disabled
                      title="{{ 'GESTORPREAPROBADO.BTN_INVITAR_BILLETERA' | translate }}">
                <img src="assets/icons/preaprobados/ico-celular-telefono-dispositivo-movil.svg" alt="invitar billetera" />
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center">{{ 'GESTORPREAPROBADO.MSG_SIN_OFERTAS' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>

  </div>

  </div>

</div>

<!-- Modal rechazo oferta -->
<p-dialog
  [(visible)]="mostrarModalRechazo"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px' }"
  styleClass="modal-rechazo-oferta"
  class="overflow-y-unset">

  <ng-template pTemplate="header">
    <div class="modal-rechazo-header">
      <span class="modal-rechazo-titulo">{{ 'GESTORPREAPROBADO.LBL_RECHAZAR_OFERTA' | translate }}</span>
      <button class="modal-rechazo-cerrar" (click)="cerrarModalRechazo()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <div class="modal-rechazo-body" [formGroup]="formRechazo">
    <div class="campo-grupo">
      <label class="campo-label campo-requerido">{{ 'GESTORPREAPROBADO.LBL_CAUSAL_RECHAZO' | translate }}</label>
      <p-dropdown
        formControlName="causal"
        [options]="ListasCausalesCancelaciones"
        optionLabel="label"
        [placeholder]="'GESTORPREAPROBADO.LBL_SELECCIONAR' | translate"
        [filter]="true"
        filterBy="descripcion"
        [style]="{ width: '100%' }">
      </p-dropdown>
      <div class="p-message p-messages-error p-corner-all"
           *ngIf="submittedRechazo && fRechazo['causal'].invalid">
        {{ 'GESTORPREAPROBADO.LBL_CAUSAL_RECHAZO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
      </div>
    </div>

    <div class="campo-grupo">
      <label class="campo-label">{{ 'GESTORPREAPROBADO.LBL_COMENTARIOS' | translate }}</label>
      <textarea
        pInputTextarea
        formControlName="comentario"
        [maxlength]="maxCaracteresComentario"
        [placeholder]="'GESTORPREAPROBADO.LBL_INGRESAR' | translate"
        rows="4"
        style="width: 100%; resize: none;">
      </textarea>
      <span class="contador-caracteres">{{ fRechazo['comentario'].value?.length || 0 }}/{{ maxCaracteresComentario }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button awButton awColor="green" (click)="cerrarModalRechazo()">
      {{ 'GESTORPREAPROBADO.BTN_CANCELAR' | translate }}
    </button>
    <button awButton awColor="green" awFill
            awIcon="assets/icons/preaprobados/ico-exitoso-check-circulo-si-exito-chulo.svg"
            (click)="guardarRechazo()">
      {{ 'GESTORPREAPROBADO.BTN_ACEPTAR' | translate }}
    </button>
  </ng-template>
</p-dialog>
